import { GLOBAL_STYLESHEET_KEY } from '@fluentui/merge-styles';
import { useMergeStylesHooks } from '../hooks/useMergeStylesHooks';
import { useMergeStylesShadowRootContext } from '../hooks/useMergeStylesShadowRoot';
export var MergeStylesShadowRootConsumer = function MergeStylesShadowRootConsumer(_a) {
  var stylesheetKey = _a.stylesheetKey,
    children = _a.children;
  var _b = useMergeStylesHooks(),
    useAdoptedStylesheetEx = _b.useAdoptedStylesheetEx,
    useMergeStylesRootStylesheets = _b.useMergeStylesRootStylesheets,
    useWindow = _b.useWindow;
  var shadowCtx = useMergeStylesShadowRootContext();
  var rootMergeStyles = useMergeStylesRootStylesheets();
  var win = useWindow();
  useAdoptedStylesheetEx(GLOBAL_STYLESHEET_KEY, shadowCtx, rootMergeStyles, win);
  useAdoptedStylesheetEx(stylesheetKey, shadowCtx, rootMergeStyles, win);
  return children(!!shadowCtx);
};